import { Feather } from "@expo/vector-icons";
import { Text } from "@ui-kitten/components";
import { LIGHT_BLUE } from "constants/";
import dayjs from "dayjs";
import { PlanPackageDetails, SignupChargeDetails } from "features/types";
import useSignupCharge from "hooks/useSignupCharge";
import React, { useState } from "react";
import { Pressable, View } from "react-native";
import { formatCurrency } from "utils/appUtils";
import Dialog from "./Dialog";
interface BuyFlowPaymentDetailCardProps {
  planPackage: PlanPackageDetails;
  signupCharge?: SignupChargeDetails;
}

export const actualBillingStartMonth = (
  billingEndAt: string,
  remainingMonths: number
) => {
  if (!billingEndAt) return "";
  const billingStartDate = dayjs(billingEndAt)
    .utc()
    .subtract(remainingMonths - 1, "months") // Inclusive of the billing end date
    .format("MMMM YYYY");
  return billingStartDate;
};

const BuyFlowPaymentDetailCard: React.FC<BuyFlowPaymentDetailCardProps> = ({
  planPackage,
  signupCharge,
}) => {
  // if a signup charge is passed in, we want to use that, otherwise default to selected plan package's signup charge
  const actualSignupCharge = signupCharge || planPackage.signupCharge;

  const { remainingMonths, billingInterval } = actualSignupCharge;

  const [visible, setVisible] = useState(false);

  const closePopover = () => setVisible(false);

  const { totalCharge, totalRecurringCharge } =
    useSignupCharge(actualSignupCharge);

  const { rollingBilling } = planPackage;
  return (
    <View>
      <Dialog
        visible={visible}
        setVisible={setVisible}
        okText="Got it!"
        onOk={closePopover}
        okBtnProps={{
          status: "primary",
        }}
      >
        <View>
          <Text category="h6" style={{ marginBottom: 8 }}>
            Amount Due Today
          </Text>
          <Text>
            The first month's subscription fee is due at time of purchase. If
            joining after the season starts, you will pay a prorated amount for
            the number of events remaining in the current billing month at the
            time of purchase.
          </Text>
        </View>
      </Dialog>
      <View
        style={{
          marginTop: 20,
          borderWidth: 1,
          borderRadius: 12,
          padding: 15,
        }}
      >
        <View style={{ alignItems: "center", justifyContent: "center" }}>
          {billingInterval === "MONTHLY" ? (
            <View style={{ alignItems: "center" }}>
              <View className="flex-row items-center">
                <Text>Amount Due Today </Text>
                {!planPackage.disableProration && (
                  <Pressable onPress={() => setVisible(true)}>
                    <Feather name="info" size={14} color={LIGHT_BLUE} />
                  </Pressable>
                )}
              </View>
              <Text category="h6" style={{ marginVertical: 5 }}>
                {formatCurrency(totalCharge)}
              </Text>
              <Text>then</Text>
              <Text category="h6" style={{ marginVertical: 5 }}>
                {formatCurrency(totalRecurringCharge)} / month
              </Text>
              {/* For rolling billing plans, do not show remaining months */}
              <Text>
                {`${
                  rollingBilling ? "" : `For ${remainingMonths} months. `
                }Starting ${actualBillingStartMonth(
                  planPackage.billingEndAt,
                  remainingMonths
                )}`}
              </Text>
            </View>
          ) : (
            <View style={{ alignItems: "center" }}>
              <Text category="h6">
                Pay in full : {formatCurrency(totalCharge)}
              </Text>
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default BuyFlowPaymentDetailCard;
